<template>
  <div class="container">
    <div class="tabs" :style="{marginTop: '-50px', marginLeft: '-30px'}">
      <ul>
        <li :class="{'is-active': isActive == 'general'}" @click="Tabs('general')">
          <a>ລູກຄ້າທົ່ວໄປ</a>
        </li>
        <li @click="Tabs('pre-general')" :class="{'is-active': isActive == 'pre-general'}">
          <a>pre-customer</a>
        </li>
      </ul>
    </div>

    <GeneralCustomer v-if="isActive == 'general'"/>
    <PreGeneralCustomer v-else/>
  </div>
</template>

<script>
import GeneralCustomer from './list-general';
import PreGeneralCustomer from './list-pre-general';

export default {
  components:{
    GeneralCustomer,
    PreGeneralCustomer
  },

  data:()=>({
    isActive: false,
  }),

  methods:{
    Tabs(value){
      this.isActive = value;
      this.$router.push({name: 'tab.general.customer', query:{tab: value}});
    }
  },
  created(){
    if(this.$route.query.tab == 'general'){
      this.isActive = 'general';
    }else if(this.$route.query.tab == 'pre-general'){
      this.isActive = 'pre-general';
    }else{
      this.isActive = 'general';
    }
  }
}
</script>

<style>

</style>